import loadable from '@loadable/component';
import loadableModule from '../../components/loadable-module';

const PropertyTypesModule = loadableModule({
    LoadableComponent: loadable(() =>
        import(
            /* webpackChunkName: "property-types" */
            './'
        )
    ),
    componentName: 'PropertyTypes',
    placeholder: {
        cardType: 'CardType1',
        placeholderType: 'Carousel',
        size: 'md',
    },
});
export default PropertyTypesModule;
